var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhoneTeal = function SvgPhoneTeal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#244D5A",
    fillRule: "evenodd",
    d: "M4.357 2.639a2.18 2.18 0 0 1 3.262.204l2.244 2.882a2.18 2.18 0 0 1 .394 1.868l-.684 2.737a.85.85 0 0 0 .222.804l3.072 3.07a.85.85 0 0 0 .804.223l2.737-.683a2.18 2.18 0 0 1 1.867.393l2.883 2.243a2.18 2.18 0 0 1 .203 3.263l-1.292 1.293c-.925.925-2.308 1.331-3.596.877A23.3 23.3 0 0 1 7.71 16.29a23.3 23.3 0 0 1-5.524-8.761c-.453-1.288-.047-2.672.878-3.597z",
    clipRule: "evenodd"
  })));
};
export default SvgPhoneTeal;